import {mapActions, mapGetters, mapMutations} from "vuex";
import _ from "lodash";
import moment from "moment";

import notificationsItem from '@/modules/notifications/list/item/index.vue'
import paginatorRequest from '@/components/paginator-request/index.vue'

export default {
  name: 'notificationsList',
  //---components
  components: {
    notificationsItem,
    paginatorRequest
  },
  //---data
  data () {
    return {
      currentDate: moment().format('MM/DD/YYYY'),
      decoratedNotifications: []
    }
  },
  //---hooks
  created: function () {},
  computed: {
    ...mapGetters({
      notifications: 'NOTIFICATIONS/notifications',
      notificationsMeta: 'NOTIFICATIONS/notificationsMeta',
    }),
  },
  watch: {
    notifications: function () {
      this._decorateNotifications();
    }
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      setNotificationsMeta: 'NOTIFICATIONS/NOTIFICATIONS_META_SET',
    }),
    ...mapActions({
      getNotifications: 'NOTIFICATIONS/NOTIFICATIONS_REQUEST_GET'
    }),

    getPage(pageId) {
      this.loaderFlag(true);

      let notificationsMeta = _.cloneDeep(this.notificationsMeta);
      notificationsMeta.pageId = pageId;
      this.setNotificationsMeta(notificationsMeta);

      this.getNotifications().then(() => {
        this.loaderFlag(false);
      });
    },

    _decorateNotifications() {
      if (this.notifications && this.notifications.length > 0) {
        let collection = [];

        this.notifications.forEach(item => {
          if (collection.length === 0 ){
            let group = {
              date: moment(item.date).format('MM/DD/YYYY'),
              list: []
            };
            group.list.push(item);
            collection.push(group)
          } else {
            let isFindGroup = false;

            collection.forEach(itemCollection => {
             if (moment(item.date).format('MM/DD/YYYY') === moment(itemCollection.date).format('MM/DD/YYYY')) {
               itemCollection.list.push(item);
               isFindGroup = true;
             }
            });

            if (!isFindGroup) {
              let group = {
                date: moment(item.date).format('MM/DD/YYYY'),
                list: []
              };
              group.list.push(item);
              collection.push(group)
            }
          }
        });

        this.decoratedNotifications = _.orderBy(collection, ['date'], ['desc']);
      } else {
        this.decoratedNotifications = [];
      }
    }
  }
}